import { staticContentAxios as axios } from './configuration/axiosConfig';
import { ClientResponse } from '../model/types/ClientResponse';

export const getChronologickyRegisterZakonovRocnikHtmlContent = async (year: string|undefined):
  Promise<ClientResponse<string>> => {
  const {
    data, status,
  } = await axios.get(
    `static/SK/ZZ/${year}/index.portal`,
  );

  return {
    data,
    responseCode: status,
  };
};
